import { Entry, EntryCollection } from 'contentful';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { richTextOptions } from './rich-text-options.model';

export class PrivacyPageContentModel {

    // Main fields from Contentful content type
    heroTitle!: string;
    heroImageURL!: string;
    heroBreadCrumbs!: string;

    masterHeader!: string;
    masterSubHeader!: string;
    linkHeader!: string;
    
    // Header link fields
    linkHeaderTypesofPersonalInformation!: string;
    linkHeaderCollectionofPersonalInformation!: string;
    linkHeaderProcessingOfPersonalInformation!: string;
    linkHeaderDisclosureofPersonalInformation!: string;
    linkHeaderTrackingTechnologies!: string;
    linkHeaderYourRightsandChoices!: string;
    linkHeaderProtectPersonalInformation!: string;
    linkHeaderKeepYourPersonalInformation!: string;
    linkHeaderImportantInformation!: string;
    linkHeaderContactInformation!: string;
    
    // Sub header rich text fields
    subHeaderTypesOfPersonalInformation!: string;
    subHeaderCollectionofPersonalInformation!: string;
    subHeaderProcessingOfPersonalInformation!: string;
    subHeaderDisclosureofPersonalInformation!: string;
    subHeaderTrackingTechnologies!: string;
    subTrackingtechnology!: string;
    subHeaderYourRightsandChoices!: string;
    subHeaderProtectPersonalInformation!: string;
    subHeaderKeepYourPersonalInformation!: string;
    subHeaderImportantInformation!: string;
    subHeaderContactInformation!: string;
    
    // Table headers and data
    tblHeaderPersonalInfo!: any;
    tableTypesOfPersonalInformation!: any;
    tblHeaderTrackingtechnology!: any;
    tableTrackingTechnology!: any;

    constructor(entries?: EntryCollection<any>) {
        if (entries && entries.items.length > 0 && entries.items[0].fields) {
            const contentDetail: any = entries.items[0].fields;

            this.heroTitle = contentDetail.title || '';
            this.heroImageURL = contentDetail.image?.fields?.file?.url;
            this.heroBreadCrumbs = contentDetail.breadcrumbs || '';
            // Main header fields 
            this.linkHeader = contentDetail.linkHeader || '';
            
            // Header link fields
            this.linkHeaderTypesofPersonalInformation = contentDetail.linkHeaderTypesofPersonalInformation || '';
            this.linkHeaderCollectionofPersonalInformation = contentDetail.linkHeaderCollectionofPersonalInformation || '';
            this.linkHeaderProcessingOfPersonalInformation = contentDetail.linkHeaderProcessingOfPersonalInformation || '';
            this.linkHeaderDisclosureofPersonalInformation = contentDetail.linkHeaderDisclosureofPersonalInformation || '';
            this.linkHeaderTrackingTechnologies = contentDetail.linkHeaderTrackingTechnologies || '';
            this.linkHeaderYourRightsandChoices = contentDetail.linkHeaderYourRightsandChoices || '';
            this.linkHeaderProtectPersonalInformation = contentDetail.linkHeaderProtectPersonalInformation || '';
            this.linkHeaderKeepYourPersonalInformation = contentDetail.linkHeaderKeepYourPersonalInformation || '';
            this.linkHeaderImportantInformation = contentDetail.linkHeaderImportantInformation || '';
            this.linkHeaderContactInformation = contentDetail.linkHeaderContactInformation || '';

            // Rich text fields with proper conversion
            if (contentDetail.masterSubHeader) {
                this.masterSubHeader = documentToHtmlString(contentDetail.masterSubHeader, richTextOptions);
            }
            if (contentDetail.subHeaderTypesOfPersonalInformation) {
                this.subHeaderTypesOfPersonalInformation =
                    documentToHtmlString(contentDetail.subHeaderTypesOfPersonalInformation, richTextOptions);
            }
            if (contentDetail.subHeaderCollectionofPersonalInformation) {
                this.subHeaderCollectionofPersonalInformation =
                    documentToHtmlString(contentDetail.subHeaderCollectionofPersonalInformation, richTextOptions);
            }
            if (contentDetail.subHeaderProcessingOfPersonalInformation) {
                this.subHeaderProcessingOfPersonalInformation =
                    documentToHtmlString(contentDetail.subHeaderProcessingOfPersonalInformation, richTextOptions);
            }
            if (contentDetail.subHeaderDisclosureofPersonalInformation) {
                this.subHeaderDisclosureofPersonalInformation =
                    documentToHtmlString(contentDetail.subHeaderDisclosureofPersonalInformation, richTextOptions);
            }
            if (contentDetail.subHeaderTrackingTechnologies) {
                this.subHeaderTrackingTechnologies = 
                    documentToHtmlString(contentDetail.subHeaderTrackingTechnologies, richTextOptions);
            }
            if (contentDetail.subTrackingtechnology) {
                this.subTrackingtechnology = 
                    documentToHtmlString(contentDetail.subTrackingtechnology, richTextOptions);
            }
            if (contentDetail.subHeaderYourRightsandChoices) {
                this.subHeaderYourRightsandChoices = 
                    documentToHtmlString(contentDetail.subHeaderYourRightsandChoices, richTextOptions);
            }
            if (contentDetail.subHeaderProtectPersonalInformation) {
                this.subHeaderProtectPersonalInformation =
                    documentToHtmlString(contentDetail.subHeaderProtectPersonalInformation, richTextOptions);
            }
            if (contentDetail.subHeaderKeepYourPersonalInformation) {
                this.subHeaderKeepYourPersonalInformation =
                    documentToHtmlString(contentDetail.subHeaderKeepYourPersonalInformation, richTextOptions);
            }
            if (contentDetail.subHeaderImportantInformation) {
                this.subHeaderImportantInformation =
                    documentToHtmlString(contentDetail.subHeaderImportantInformation, richTextOptions);
            }
            if (contentDetail.subHeaderContactInformation) {
                this.subHeaderContactInformation = 
                    documentToHtmlString(contentDetail.subHeaderContactInformation, richTextOptions);
            }
            
            // Table and object fields
            if (contentDetail.tblHeaderPersonalInfo) {
                this.tblHeaderPersonalInfo = contentDetail.tblHeaderPersonalInfo;
            }
            if (contentDetail.tableTypesOfPersonalInformation) {
                this.tableTypesOfPersonalInformation = contentDetail.tableTypesOfPersonalInformation;
            }
            if (contentDetail.tblHeaderTrackingtechnology) {
                this.tblHeaderTrackingtechnology = contentDetail.tblHeaderTrackingtechnology;
            }
            if (contentDetail.tableTrackingTechnology) {
                this.tableTrackingTechnology = contentDetail.tableTrackingTechnology;
                
                // Process URLs in tableTrackingTechnology
                for (let i = 0; i < this.tableTrackingTechnology.length; i++) {
                    if (this.tableTrackingTechnology[i].url && this.tableTrackingTechnology[i].url !== '' && this.tableTrackingTechnology[i].urlText) {
                        const URL = this.tableTrackingTechnology[i].urlText;
                        this.tableTrackingTechnology[i].Description = 
                            this.tableTrackingTechnology[i].Description.replace(URL, '<a href="' 
                            + this.tableTrackingTechnology[i].url + '" target="_self">' + URL + '</a>');
                    }
                }
            }
        }
    }
}
